export const AgentFlightBookingData = [
  {
    key: "1",
    id: "#FB-1245",
    flightName: "Antonov An-32",
    flightType: "Air India",
    bookedBy: "Lynwood Dickens",
    bookedLocation: "Texas",
    tickect:"Business Class",
    members:"2 Adults, 1 Child",
    from_to: "London - Paris",
    pricing: "$11,569",
    bookedOn: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#FB-3215",
    flightName: "SkyBound 102",
    flightType: "Japan Airlines",
    bookedBy: "James Osborne",
    bookedLocation: "California",
    tickect:"Economy",
    members:"2 Adults, 2 Child",
    from_to: "Los Angeles - Tokyo",
    pricing: "$10,745",
    bookedOn: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#FB-4581",
    flightName: "Nimbus 345",
    flightType: "Qatar Airways",
    bookedBy: "Steve Grieve",
    bookedLocation: "Newyork",
    tickect:"Fare Economy",
    members:"3 Adults, 2 Child",
    from_to: "London - Dubai",
    pricing: "$8,160",
    bookedOn: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#FB-6545",
    flightName: "AstraFlight 215",
    flightType: "Emirates",
    bookedBy: "Alene Downing",
    bookedLocation: "Florida",
    tickect:"Suite",
    members:"2 Adults, 1 Child",
    from_to: "Atlanta - Barcelona",
    pricing: "$14,840",
    bookedOn: "17 Jun 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "5",
    id: "#FB-3256",
    flightName: "Cloudrider 789",
    flightType: "Air France",
    bookedBy: "Carol Gardner",
    bookedLocation: "Georgia",
    tickect:"Economy",
    members:"1 Adult, 1 Child",
    from_to: "Chicago - Frankfurt",
    pricing: "$10,450",
    bookedOn: "25 Jun 2025",
    status: "Upcoming",
    action: "Upcoming",
  },
  {
    key: "6",
    id: "#FB-3654",
    flightName: "Aether Express 901",
    flightType: "American Airlines",
    bookedBy: "Enrique Archer",
    bookedLocation: "Las Vegas",
    tickect:"First Class",
    members:"3 Adults, 2 Child",
    from_to: "Miami - Madrid",
    pricing: "$12,600",
    bookedOn: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#FB-1458",
    flightName: "Voyager 658",
    flightType: "Air Canada",
    bookedBy: "Weston Carrasco",
    bookedLocation: "Texas",
    tickect:"Economy",
    members:"2 Adults, 3 Child",
    from_to: "Toronto - Rome",
    pricing: "$9,380",
    bookedOn: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "8",
    id: "#FB-6589",
    flightName: "Delta D118",
    flightType: "Air Arabia",
    bookedBy: "Bonnie Coleman",
    bookedLocation: "California",
    tickect:"Fare Economy",
    members:"2 Adults, 2 Child",
    from_to: "Boston - Amsterdam",
    pricing: "$10,400",
    bookedOn: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#FB-2315",
    flightName: "Silverwing 505",
    flightType: "Air Europa",
    bookedBy: "Aurora Conklin",
    bookedLocation: "Georgia",
    tickect:"Business Class",
    members:"1 Adult, 1 Child",
    from_to: "Dallas - London",
    pricing: "$12,810",
    bookedOn: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#FB-5414",
    flightName: "Altair 333",
    flightType: "Azores Airlines",
    bookedBy: "Robin Banks",
    bookedLocation: "Las Vegas",
    tickect:"Business Class",
    members:"2 Adults, 1 Child",
    from_to: "Seattle - Seoul",
    pricing: "$15,450",
    bookedOn: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },
 
];
